import React, { useState, useEffect } from "react";
import { Row, Col, Card, Form, Input, Spin, PageHeader, Table, Button, Alert } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { PrinterOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { CustomBtn } from "../../../components/Button";
import { woyofalClearState } from "../../../redux/bills/bill-woyofal-slice";
import { getTransactionAsync, transactionClearState } from "../../../redux/transaction/transaction-slice";
import { API_ROOT } from "../../../utils/api-config";
import { useBillFeesMutation, useBillWoyofalGetMutation, useBillWoyofalReloadMutation } from "../service/bill-api";
import TransactionResume from "../../../components/Dialog/transaction-resume";
import SuccessDialog from "../../../components/Dialog/success";

export function BillWoyofalPage() {
    const dispatch = useDispatch();
    const { currentAgent } = useSelector((state) => state.auth);
    const [form] = Form.useForm();
    const woyofal = useSelector((state) => state.billWoyofal);
    const [montant, setMontant] = useState("");
    const transaction = useSelector((state) => state.transaction);
    const [compteur, setCompteur] = useState("");
    const [billWoyofalGet] = useBillWoyofalGetMutation()
    const [billWoyofalReload] = useBillWoyofalReloadMutation()
    const [billFees] = useBillFeesMutation();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const [customer, setCustomer] = useState(null);
    const [show, setShow] = useState(false);
    const [fees, setFees] = useState();
    const [formdata, setFormData] = useState();
    const [isSuccess, setIsSuccess] = useState(false);


    const handleSearch = async (value) => {
        setIsLoading(true);
        const data = {
            "agent_msisdn": currentAgent.phone,
            "agent_pin": "",
            "country": currentAgent.country,
            "meter_no": value.compteur_number,
            "amount": value.amount,
            "token": currentAgent.access_token,
        }
        billWoyofalGet(data)
            .unwrap()
            .then((res) => {
                setCustomer(value.phone_number)
                setMontant(value.amount)
                setCompteur(value.compteur_number)
                setIsLoading(false);
                form.setFieldsValue({
                    customer_name: res.customer_info.customer_name,
                    energy: res.energy,
                    tarif_type: res.tarif_type,
                });
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.message);
            });
    }

    const handleFees = async (value) => {
        setIsLoading(true);
        const data = {
            "country": currentAgent.country,
            "montant": value.amount,
            "operation": "WOYOFAL",
            "pincode": "",
            "receiver": value.phone_number,
            "token": currentAgent.access_token
        };
        setFormData(value);
        billFees(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setError();
                setFees(res);
                setShow(true);
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    };

    const handlePay = async (pin) => {
        setShow(false);
        setIsLoading(true);
        const data = {
            "token": currentAgent.access_token,
            "agent_msisdn": currentAgent.phone_number,
            "agent_pin": pin,
            "country": currentAgent.country,
            "meter_no": compteur,
            "amount": montant,
            "receveurmsisdn": customer
        }
        billWoyofalReload(data)
            .unwrap()
            .then(() => {
                setIsSuccess(true);
                setShow(false);
                setIsLoading(false);
                setCustomer(null)
                form.resetFields();
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    }

    const handleTransaction = async () => {
        const data = {
            "count": 10,
            "country": currentAgent.country,
            "pincode": "",
            "token": currentAgent.access_token,
            "type": "payment_woyofal"
        }
        dispatch(getTransactionAsync(data))

    }

    form.setFieldsValue({ firstname: woyofal?.customer_info?.customer_name });


    const columns = [
        {
            title: 'ID transactions',
            dataIndex: 'id',
        },
        {
            title: 'Dates',
            dataIndex: 'datetransformatted',
        },
        {
            title: 'Téléphones',
            responsive: ['lg'],
            dataIndex: 'receiver',
        },
        {
            title: 'Montants',
            render: (record) => <span>{record.amount} FCFA</span>
        },
        {
            title: 'Imprimer',
            responsive: ['lg'],
            render: (record) => <span><a href={API_ROOT + "api/imprime/factures/" + record.id + "/?token=" + currentAgent.access_token + "&country=" + currentAgent.country + ""} rel="noopener noreferrer" target="_blank">< PrinterOutlined style={{ fontSize: '20px' }} /> </a ></span >
        }
    ];


    useEffect(() => {
        if (woyofal.isSuccess) {
            dispatch(woyofalClearState())
            form.resetFields()
        }
    }, [woyofal, dispatch, form]);

    useEffect(() => {
        return () => {
            dispatch(transactionClearState())
            dispatch(woyofalClearState())
        };
    }, [dispatch, form]);


    return (
        <div className="default-page">
            <TransactionResume
                title="PAIEMENT WOYOFAL"
                message={
                    "Vous allez effectuer un payement WOYOFAL d'un montant de " +
                    fees?.amount +
                    " F CFA"
                }
                fees={fees?.fees}
                status={show}
                handleCancel={() => setShow(false)}
                handlePay={handlePay}
            />
            <SuccessDialog
                message="Paiement effectué avec succès"
                status={isSuccess}
                handleCancel={() => setIsSuccess(false)}
            />
            <PageHeader title="PAIEMENT WOYOFAL" />
            <Spin tip="Chargement..." spinning={isLoading}>
                <Row gutter={16}>
                    <Col lg={12} xs={24}>
                        <Card>
                            <Form
                                name="basic"
                                form={form}
                                layout="vertical"
                                initialValues={{ remember: true }}
                                onFinish={customer ? handleFees : handleSearch}
                            >
                                <Form.Item
                                    label="Numero du client"
                                    name="phone_number"
                                    rules={[{ required: true, message: "Veuillez saisir un numéro" }]}>
                                    <Input
                                        className="form-control"
                                        placeholder="Numero du client"
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Numero du compteur"
                                    name="compteur_number"
                                    rules={[{ required: true, message: "Veuillez saisir un numéro" }]}>
                                    <Input
                                        className="form-control"
                                        placeholder="Numero du compteur"
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Montant"
                                    name="amount"
                                    rules={[{ required: true, message: "Veuillez saisir un montant" }]}>
                                    <Input className="form-control" placeholder="Montant" />
                                </Form.Item>

                                {customer && (
                                    <div>
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <Form.Item
                                                    label="Nom client"
                                                    name="customer_name">
                                                    <Input className="form-control" prefix={<UserOutlined />} disabled />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Form.Item
                                                    label="Energie"
                                                    name="energy">
                                                    <Input className="form-control" suffix={"KWH"} disabled />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label="Type"
                                                    name="tarif_type">
                                                    <Input className="form-control" disabled />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                                <Form.Item>
                                    <CustomBtn title={customer ? "Valider" : "Chercher"} />
                                </Form.Item>
                            </Form>
                            {error && (
                                <Form.Item>
                                    <Alert message={error} type="error" showIcon />
                                </Form.Item>
                            )}
                        </Card>
                    </Col>
                    <Col lg={12} xs={24}>
                        <Card>
                            <Table
                                dataSource={transaction.data}
                                locale={{
                                    emptyText: (transaction.data) ?
                                        null
                                        : (
                                            <Button
                                                onClick={() => handleTransaction()}
                                                size="large"
                                                className="btn btn-secondary">
                                                {"Afficher l'historique des transactions"}
                                            </Button>
                                        )
                                }}
                                loading={transaction.isFetching}
                                columns={columns} />
                        </Card>
                    </Col>
                </Row>

            </Spin>

        </div>
    );
}
export default BillWoyofalPage;
